export default __webpack_public_path__ + "static/media/ventana.2441f427.png";